export function parseDate(value: string): Date | null {
  if (!value || value.trim() === "") return null;
  const parts = value.trim().split(".");
  if (parts.length !== 3) return null;
  const [d, m, y] = parts.map(Number);
  if (Number.isNaN(d) || Number.isNaN(m) || Number.isNaN(y)) return null;
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function formatDate(date: Date | null): string {
  if (!date) return "";
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

/** ISO 8601 string to form date string (dd.MM.yyyy) - timezone-safe, sadece YYYY-MM-DD kısmı kullanılır */
export function isoToFormDate(iso: string | undefined): string {
  if (!iso || !iso.trim()) return "";
  const datePart = iso.slice(0, 10);
  const match = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return "";
  const [, y, m, d] = match;
  return `${d}.${m}.${y}`;
}

/** DD.MM.YYYY string to ISO 8601 at start of day (for startDate) */
export function formDateToISOStart(dateStr: string): string {
  const d = parseDate(dateStr);
  if (!d) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}T00:00:00.000Z`;
}

/** DD.MM.YYYY string to ISO 8601 at end of day (for endDate) - yerel gün sonu kullanılır (timezone kaymasını önler) */
export function formDateToISOEnd(dateStr: string): string {
  const d = parseDate(dateStr);
  if (!d) return "";
  const endOfDay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
  return endOfDay.toISOString();
}

/** Date objesinden yerel tarih ile ISO 8601 (timezone hatasını önler) */
function dateToLocalISOString(d: Date, endOfDay = false): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const time = endOfDay ? "23:59:59.999" : "00:00:00.000";
  return `${y}-${m}-${day}T${time}Z`;
}

/** Tarih aralığı [Date, Date] → API için dateFrom, dateTo (yerel tarih kullanır) */
export function parseDateRangeToISO(
  value: [Date | null, Date | null] | undefined
): { dateFrom?: string; dateTo?: string } {
  if (!value || !Array.isArray(value)) return {};
  const [start, end] = value;
  return {
    dateFrom:
      start && !Number.isNaN(start.getTime())
        ? dateToLocalISOString(start, false)
        : undefined,
    dateTo:
      end && !Number.isNaN(end.getTime())
        ? dateToLocalISOString(end, true)
        : undefined,
  };
}
